import { ChevronRight } from 'lucide-react';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

import { DEFAULT_QUICK_ACTIONS, type QuickAction } from './types';

export interface QuickActionsProps extends Omit<ComponentProps<'div'>, 'children'> {
  /** Quick actions to display. Defaults to DEFAULT_QUICK_ACTIONS. */
  actions?: readonly QuickAction[];
  /** Callback when an action is clicked, receives the prompt text. */
  onAction: (prompt: string) => void;
}

export function QuickActions({
  actions = DEFAULT_QUICK_ACTIONS,
  onAction,
  className,
  ...props
}: QuickActionsProps) {
  if (actions.length === 0) {
    return null;
  }

  return (
    <div className={cn('flex flex-col gap-1', className)} {...props}>
      {actions.map((action) => (
        <button
          key={action.id}
          type="button"
          className="group flex items-center justify-between rounded-md px-2 py-1.5 text-left text-sm text-muted-foreground hover:bg-muted hover:text-foreground"
          onClick={() => onAction(action.prompt)}
        >
          {action.label}
          <ChevronRight className="h-4 w-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" />
        </button>
      ))}
    </div>
  );
}
